/**
 * Invoices Routes
 */
/* eslint-disable */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

// async components
import {
  AsyncAddInvoiceComponent,
  AsyncCreateSupplierBillComponent,
  AsyncManageInvoicesComponent,
  AsyncModifyInvoiceComponent,
} from "../../components/AsyncComponent/AsyncComponent";

const Forms = ({ match }) => (
  <React.Fragment>
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/manage`} />
      <Route
        path={`${match.url}/view-all`}
        component={AsyncManageInvoicesComponent}
      />
      <Route
        path={`${match.url}/create`}
        component={AsyncAddInvoiceComponent}
      />
      <Route
        path={`${match.url}/create-supplier-bill`}
        component={AsyncCreateSupplierBillComponent}
      />
      <Route
        path={`${match.url}/modify`}
        component={AsyncModifyInvoiceComponent}
      />
    </Switch>
  </React.Fragment>
);

export default Forms;
